import React, { useState, useEffect } from 'react';
import { RadioButton } from 'react-native-paper';
import { StyleSheet, SafeAreaView, Platform, useWindowDimensions, Pressable } from 'react-native';
import StarRating from 'react-native-star-rating-widget';
import Slider from '@react-native-community/slider';
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import CustomInput from '../../CustomInput/CustomInput';
import CustomLabel from '../../CustomLabel/CustomLabel';

const CustomQuestionOptions = ({ input_type_name, response, handleQuestionOptionChange, handleQuestionRatingOptionChange, question_option_id, questionOptionResponseList, question_option_name, questionId, allow_mutiple_option_answers_yn, question_required_yn,
    isResponse = 0, isResult = 0, sectionIndex, questionIndex, index }) => {

    const { colors } = useTheme()
    const { width, height } = useWindowDimensions()
    const styles = makeStyles(colors, width)
    const { t } = useTranslation();

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    // * Combinations for enabling disabling the complition of boxes 
    var isDisabled = true;
    if (isResponse === 1 && isResult === 0) {
        isDisabled = false;
    }
    // * Load value depending on question option id
    var respValue = 0;
    if (isResult === 1) {
        questionOptionResponseList.map((qorItr) => {
            if (qorItr.question_option_id === question_option_id) {
                if (input_type_name === "Text") {
                    respValue = qorItr.answer_text
                }
                else if (input_type_name === "Slider" || input_type_name === "Rating(10)" || input_type_name === "Rating(5)") {
                    respValue = qorItr.answer_numeric
                }
                else if (input_type_name === "Options" || input_type_name === "True/False Options" || input_type_name === "Rating Options") {
                    respValue = qorItr.answer_yn === 0 || qorItr.answer_yn === 2 ? false : true
                }
            }
        })
    }
    else {
        if (questionOptionResponseList) {
            questionOptionResponseList.map((qorItr) => {
                if (qorItr.question_option_id === question_option_id) {
                    if (input_type_name === "Options" || input_type_name === "True/False Options" || input_type_name === "Rating Options") {
                        respValue = qorItr.answer_yn === 0 || qorItr.answer_yn === 2 ? false : true
                    }
                    else if (input_type_name === "Text") {
                        respValue = qorItr.answer_text
                    }
                    else if (input_type_name === "Slider" || input_type_name === "Rating(10)" || input_type_name === "Rating(5)") {
                        respValue = qorItr.answer_numeric
                    }
                }
            })
        }
    }

    return (
        <SafeAreaView
            style={styles.main}>
            {input_type_name === "Options" &&
                <SafeAreaView
                    style={styles.row}>
                    {!isResponse ?
                        <SafeAreaView>
                            <SafeAreaView style={{ display: 'flex', position: 'relative', top: '25px' }}>
                                <RadioButton
                                    width={'25%'}
                                />
                            </SafeAreaView>
                            <SafeAreaView style={{ display: 'flex', position: 'relative', width: '80%' }}>
                                <CustomInput
                                    value={question_option_name === "" ? "" : question_option_name}
                                    setValue={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index)}
                                    type='SURVEYHEADER1'
                                    placeholder='Enter Option Value'
                                />
                            </SafeAreaView>
                        </SafeAreaView>
                        :
                        // when response
                        <SafeAreaView
                            style={styles.radioButton}>
                            <Pressable
                                value={question_option_name}
                                style={styles.radioButton}
                                onPress={() => {
                                    !isResult ? handleQuestionOptionChange(!respValue, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                    : {}
                                }}>
                                <CustomLabel
                                    value={question_option_name}
                                    type='MINOR'
                                />
                                <RadioButton
                                    value={question_option_name}
                                    status={respValue ? 'checked' : 'unchecked'}
                                    onPress={() => {
                                        !isResult ? handleQuestionOptionChange(!respValue, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                        : {}
                                    }}
                                />
                            </Pressable>
                        </SafeAreaView>
                    }
                </SafeAreaView>
            }
            {input_type_name === "Text" &&
                <SafeAreaView
                    style={styles.rowflex}>
                    {!isResponse &&
                        <CustomLabel
                            value={t('common:preview')}
                            type='MINOR'
                        />
                    }
                    <CustomInput
                        value={respValue === "" || respValue === 0 ? "" : respValue}
                        editable={isResult ? false : true}
                        setValue={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id)}
                        type='SURVEYHEADER2'
                        placeholder='Please enter your response'
                    />
                </SafeAreaView>
            }
            {input_type_name === "Rating(5)" &&
                // No listeners on creating the survey 
                <SafeAreaView
                    style={styles.rowflexRating}>
                    {!isResponse &&
                        <CustomLabel
                            value={t('common:preview')}
                            type='MINOR'
                        />
                    }
                    <StarRating
                        rating={respValue === "" ? "" : respValue}
                        onChange={(rating) => {
                            !isResult ? handleQuestionOptionChange(rating, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                : {}
                        }}


                        maxStars={5}
                    // style={{ marginStart: '11%' }}
                    />
                </SafeAreaView>
            }
            {/* the code below is for the new option */}
            {input_type_name === "True/False Options" &&
                <SafeAreaView
                    style={styles.row}>
                    {!isResponse ?
                        <SafeAreaView style={{ width: '100%' }}>
                            <SafeAreaView style={{ display: 'flex', position: 'relative', width: '80%' }}>
                                <CustomInput
                                    value={question_option_name === "" ? "" : question_option_name}
                                    setValue={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index)}
                                    type='SURVEYHEADER1'
                                    placeholder='Enter Option Value'
                                />
                            </SafeAreaView>
                            <SafeAreaView style={{ display: 'flex', position: 'relative', top: '25px' }}>
                                <RadioButton
                                    width={'25%'} />
                            </SafeAreaView>
                        </SafeAreaView>
                        :
                        // when Response
                        <SafeAreaView style={{width: '80%', alignItems: 'center'}}>
                            <CustomLabel
                                value={question_option_name}
                                type='MINOR'
                            />
                            <SafeAreaView
                                style={styles.rowMax}>
                                <SafeAreaView
                                    style={styles.radioButton}>
                                    <CustomLabel
                                        value={t('common:true')}
                                        type='MINOR'
                                    />
                                    <RadioButton
                                        value={question_option_name}
                                        status={respValue ? 'unchecked' : 'checked'}
                                        onPress={() => {
                                            !isResult ? handleQuestionOptionChange(!respValue, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                            : {}
                                        }
                                        }
                                    />
                                </SafeAreaView>
                                <SafeAreaView
                                    style={styles.radioButton}>
                                    <CustomLabel
                                        value={t('common:false')}
                                        type='MINOR'
                                    />
                                    <RadioButton
                                        value={question_option_name}
                                        status={respValue ? 'checked' : 'unchecked'}
                                        onPress={() => {
                                            !isResult ? handleQuestionOptionChange(!respValue, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                            : {}
                                        }}
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                </SafeAreaView>
            }
            {/* the code above is for the new option */}
            {input_type_name === "Rating Options" &&
                <SafeAreaView
                    style={styles.rowMax}>
                    {!isResponse ? (index % 6 === 5 &&
                        <SafeAreaView style={{ width: '100%' }}>
                            <SafeAreaView style={{ display: 'flex', position: 'relative', width: '80%' }}>
                                <CustomInput
                                    value={question_option_name === "" ? "" : question_option_name}
                                    setValue={(e) => handleQuestionRatingOptionChange(e, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index)}
                                    type='SURVEYHEADER1'
                                    placeholder='Enter Subquestion'
                                />
                            </SafeAreaView>
                        </SafeAreaView>)
                        // when response
                        :
                        <SafeAreaView style={{ flex: 1 }}>
                            {(index % 6 === 0) &&
                                <CustomInput
                                    editable={false}
                                    value={question_option_name === "" ? "" : question_option_name}
                                    type='SURVEYHEADER2'
                                    placeholder='Subquestion'
                                />
                            }
                            <SafeAreaView
                                style={styles.radioDirection}>
                                <SafeAreaView
                                    style={styles.radioButton}>
                                    {isResponse ? ((index % 6 === 0) ?
                                        null
                                        : (index % 6 === 1) ?
                                            <CustomLabel
                                                value={t('common:stronglyAgree')}
                                                type='MINOR' /> :
                                            (index % 6 === 2) ?
                                                <CustomLabel
                                                    value={t('common:Agree')}
                                                    type='MINOR' /> :
                                                (index % 6 === 3) ? <CustomLabel
                                                    value={t('common:neutral')}
                                                    type='MINOR' /> :
                                                    (index % 6 === 4) ? <CustomLabel
                                                        value={t('common:Disagree')}
                                                        type='MINOR' /> :
                                                        (index % 6 === 5) ? <CustomLabel
                                                            value={t('common:stronglyDisagree')}
                                                            type='MINOR' /> : null) : null}
                                    {(index % 6 === 0) ? <></> : <RadioButton
                                        value={isResponse ?
                                            ((index % 6 === 1) ?
                                                t('common:stronglyAgree') :
                                                (index % 6 === 2) ?
                                                    t('common:Agree') :
                                                    (index % 6 === 3) ? t('common:neutral') :
                                                        (index % 6 === 4) ? t('common:Disagree') :
                                                            (index % 6 === 5) ? t('common:stronglyDisagree') : null) : null}
                                        status={respValue ? 'checked' : 'unchecked'}
                                        onPress={() => {
                                            !isResult ? handleQuestionRatingOptionChange(respValue, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, question_required_yn, questionId)
                                                : {}
                                        }}
                                    />}
                                </SafeAreaView>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                    {!isResponse &&
                        <SafeAreaView
                            style={styles.columnCreateADOptions}>
                            <SafeAreaView style={{ width: "67%", marginTop: '1%', flexDirection: 'row' }}>
                                <SafeAreaView style={{ flex: 1 }}>
                                    <CustomInput
                                        value={question_option_name === "" ? "" : question_option_name}
                                        setValue={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index)}
                                        type='SURVEYHEADER1'
                                        placeholder='Enter Option Value'
                                    />
                                </SafeAreaView>
                                <SafeAreaView style={{ marginLeft: '30px', fontWeight: 'bold' }}>
                                    <CustomLabel
                                        value={t('common:stronglyAgree')}
                                        type='MINOR'
                                    />
                                    <CustomLabel
                                        value={t('common:Agree')}
                                        type='MINOR'
                                    />
                                    <CustomLabel
                                        value={t('common:neutral')}
                                        type='MINOR'
                                    />
                                    <CustomLabel
                                        value={t('common:Disagree')}
                                        type='MINOR'
                                    />
                                    <CustomLabel
                                        value={t('common:stronglyDisagree')}
                                        type='MINOR'
                                    />
                                </SafeAreaView>
                            </SafeAreaView>
                        </SafeAreaView>}
                </SafeAreaView>
            }
            {input_type_name === "Rating(10)" &&
                // No listeners on creating the survey 
                <SafeAreaView
                    style={styles.rowflexRating}>
                    {!isResponse &&
                        <CustomLabel
                            value={t('common:preview')}
                            type='MINOR'
                        />
                    }
                    <StarRating
                        rating={respValue === "" ? "" : respValue}
                        onChange={(rating) => {
                            !isResult ? handleQuestionOptionChange(rating, input_type_name, question_option_id, isResponse, sectionIndex, questionIndex, index, allow_mutiple_option_answers_yn, question_required_yn, questionId)
                                : {}
                        }} maxStars={10}
                        starSize={Platform.OS === 'web' ? 32 : 20}
                    // style={{ marginStart: '11%' }}
                    />
                </SafeAreaView>
            }

            {input_type_name === "Slider" &&
                // No listeners on creating the survey 
                <SafeAreaView
                    style={[styles.row, {width: '100%'}]}>
                        {/* * Fields to enter min and max values */}
                        {/* {!isResponse &&
                            <TextField
                                id="standard-basic"
                                name={response}
                                placeholder='Enter Min Value'
                                inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                onChange={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id)}
                                variant="standard" />
                        }
                        {!isResponse &&
                            <TextField
                                id="standard-basic"
                                name={response}
                                placeholder='Enter max Value'
                                inputProps={{ min: 0, style: { textAlign: 'center' } }}
                                onChange={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id)}
                                variant="standard" />
                        } */}
                        {!isResponse &&
                            <CustomLabel
                                value={t('common:preview')}
                                type='MINOR'
                            />
                        }
                        {isResponse ?
                            <Slider
                                style={styles.slider}
                                valueLabelDisplay="auto"
                                disabled={isDisabled}
                                value={respValue === "" ? "" : respValue}
                                onValueChange={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id)}
                            /> :
                            <Slider
                                disabled={isDisabled}
                                style={styles.slider}
                                value={respValue === "" ? "" : respValue}
                                onValueChange={(e) => handleQuestionOptionChange(e, input_type_name, question_option_id)}
                            />
                        }

                </SafeAreaView>
            }
        </SafeAreaView >
    )
};

const makeStyles = (colors, width) => StyleSheet.create({
    main: {
        flex: 1,
        alignItems: 'center',
    },
    cardstyle: {
        padding: 10,
        margin: 10,
        borderRadius: 35,
        backgroundColor: colors.background_card,
    },
    quarterwidth: {
        width: '25%'
    },
    slider: {
        width: (Platform.OS === 'web' && width > 1300) ? width / 3 : '80%',
    },
    row: {
        width: (Platform.OS === 'web' && width > 1300) ? width / 3 : '80%',
        margin: 10,
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    rowMax: {
        width: (Platform.OS === 'web' && width > 1300) ? '100%' : '80%',
        margin: 10,
        flex: 1,
        flexWrap: 'wrap',
        alignContent: 'center',
        flexDirection: Platform.OS === 'web' ? 'row' : 'column',
    },
    rowflex: {
        width: '100%',
        // flexDirection: 'row',
    },
    columnCreateADOptions: {
        width: (Platform.OS === 'web' && width > 1300) ? '100%' : '60%',
    },
    rowflexRating: {
        justifyContent: 'center',
        alignSelf: 'center',
    },
    radioDirection: {
        width: (Platform.OS === 'web' && width > 1300) ? width / 10 : width / 2,
        justifyContent: 'center',
        flexDirection: (Platform.OS === 'web' && width > 1300) ? 'row' : 'column'
    },
    radioButton: {
        justifyContent: 'center',
        flex: 1,
        alignItems: 'center',
        flexDirection: (Platform.OS === 'web' && width > 1300) ? 'column' : 'row'
    },
});

export default CustomQuestionOptions;